var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3875_86118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7312 19.2232C65.0832 24.4949 65.0832 35.4999 65.0832 35.4999C65.0832 35.4999 65.0832 46.5049 63.7312 51.7767C62.9798 54.6906 60.7817 56.9833 57.998 57.7584C52.9422 59.1666 35.4998 59.1666 35.4998 59.1666C35.4998 59.1666 18.0664 59.1666 13.0017 57.7584C10.2061 56.9715 8.011 54.6818 7.26846 51.7767C5.9165 46.5049 5.9165 35.4999 5.9165 35.4999C5.9165 35.4999 5.9165 24.4949 7.26846 19.2232C8.01988 16.3092 10.2179 14.0165 13.0017 13.2414C18.0664 11.8333 35.4998 11.8333 35.4998 11.8333C35.4998 11.8333 52.9422 11.8333 57.998 13.2414C60.7936 14.0283 62.9887 16.3181 63.7312 19.2232V19.2232ZM29.5832 45.8541L47.3332 35.4999L29.5832 25.1458V45.8541Z",
    fill: "#FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3875_86118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.84f86a4347626148253b3c9225f0e2af.svg";
export { ForwardRef as ReactComponent };